module.exports = require('./lib/no-important.js');



//////////////////
// WEBPACK FOOTER
// ./~/aphrodite/no-important.js
// module id = 953
// module chunks = 0